// Signature holo-tilt interaction for decorative .vault-holo-card elements.
// Pointer-driven only; touch/keyboard users get the static card, which is an
// intentional graceful degradation (matches the original mockup behavior).
//
// Deliberately excludes .vault-holo-card--photo (real product photos): the
// tilt + color-shifting sheen made it hard to actually see the card being
// sold, so real photos stay flat and clean. They get their own much lighter
// ambient glow via CSS only (see assets/vault-theme.css) that never touches
// the image.
(function () {
  function initHoloCards() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    document.querySelectorAll('.vault-holo-card:not(.vault-holo-card--photo)').forEach(function (card) {
      if (card.dataset.holoInit) return;
      card.dataset.holoInit = 'true';

      var face = card.querySelector('.vault-holo-face');
      if (!face) return;

      card.addEventListener('mousemove', function (e) {
        // Guard against a card that started decorative at init time but was
        // later swapped to a real product photo (e.g. vault-hero-random.js
        // picking a random featured product after this listener attached).
        if (card.classList.contains('vault-holo-card--photo')) return;

        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        var rotY = (x - 0.5) * 22;
        var rotX = (0.5 - y) * 22;
        card.style.transform = 'rotateY(' + rotY + 'deg) rotateX(' + rotX + 'deg)';
        face.style.setProperty('--mx', x * 100 + '%');
        face.style.setProperty('--my', y * 100 + '%');
        face.style.setProperty('--holo-rot', x * 360 + 'deg');
      });

      card.addEventListener('mouseleave', function () {
        if (card.classList.contains('vault-holo-card--photo')) {
          card.style.transform = '';
          return;
        }
        card.style.transform = 'rotateY(0deg) rotateX(0deg)';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoloCards);
  } else {
    initHoloCards();
  }

  // Re-scan when the theme editor injects/re-renders sections.
  document.addEventListener('shopify:section:load', initHoloCards);
})();
